import { api } from "../api";

export type NpsStatus = "shown" | "answered" | "dismissed";

export type NpsStep = {
  /** One per time the survey is shown */
  surveyId: string;
  status: NpsStatus;
  score?: number;
  comment?: string;
  /** Sent at every step: if an earlier one was lost, the next still saves the whole answer */
  context: {
    locale: string;
    device: "mobile" | "desktop";
  };
};

// Checked once per browser session: who isn't due (or already saw it) isn't asked again until the next one
const CHECKED_KEY = "nps:checked";

// The steps go one after the other: the score never reaches the API before the row created when shown
let queue: Promise<void> = Promise.resolve();

export const npsService = {
  wasChecked(): boolean {
    try {
      return sessionStorage.getItem(CHECKED_KEY) === "1";
    } catch {
      return false;
    }
  },

  markChecked() {
    try {
      sessionStorage.setItem(CHECKED_KEY, "1");
    } catch {
      // Without storage, the API's rules still keep it from showing too often
    }
  },

  isEligible(): Promise<boolean> {
    return api.getNpsEligibility();
  },

  /** Saves a step (never fails: a lost step mustn't get in the person's way) */
  save(step: NpsStep): Promise<void> {
    queue = queue.then(() => api.saveNps(step)).catch(() => undefined);
    return queue;
  },
};
